module.exports = __webpack_public_path__ + "img/saudia-4.38ecc348.png";